import { render, staticRenderFns } from "./BaiMap.vue?vue&type=template&id=216051f9"
import script from "./BaiMap.vue?vue&type=script&lang=ts"
export * from "./BaiMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports